import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import Swal from "sweetalert2";
import auth from "../firebase.init";

const MyProfile = () => {
  const [user] = useAuthState(auth);

  const [profile, setProfile] = useState({});
  const { education, number, address, linkedin } = profile;
  useEffect(() => {
    fetch(`http://localhost:5000/user/${user.email}`)
      .then((res) => res.json())
      .then((data) => setProfile(data));
  }, [user.email, profile]);

  const handleForm = (e) => {
    e.preventDefault();
    const name = e.target.name.value;
    const email = e.target.email.value;
    const number = e.target.number.value;
    const address = e.target.address.value;
    const education = e.target.education.value;
    const linkedin = e.target.linkedin.value;
    const profile = { name, email, number, address, education, linkedin };

    fetch(`http://localhost:5000/user/${email}`, {
      method: "put",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(profile),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.acknowledged) {
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: "Update profile successfully",
            showConfirmButton: false,
            timer: 1500,
          });
          e.target.reset();
        }
        console.log(data);
      });
  };

  return (
    <div className="">
      <p className="text-2xl text-center font-semibold">My Profile</p>
      <div className="md:flex">
        <div className="w-1/2">
          <form onSubmit={handleForm}>
            <div class="card-body">
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Name</span>
                </label>
                <input
                  type="text"
                  placeholder="Name"
                  name="name"
                  class="input input-bordered"
                  value={user?.displayName}
                  disabled
                />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Email</span>
                </label>
                <input
                  type="text"
                  name="email"
                  placeholder="E-mail"
                  class="input input-bordered"
                  value={user?.email}
                  disabled
                />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Education</span>
                </label>
                <input
                  type="text"
                  name="education"
                  placeholder="Education"
                  class="input input-bordered"
                />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Phone</span>
                </label>
                <input
                  type="number"
                  placeholder="Phone"
                  name="number"
                  class="input input-bordered"
                />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Address</span>
                </label>
                <input
                  type="text"
                  placeholder="Address"
                  class="input input-bordered"
                  name="address"
                />
              </div>
              <div class="form-control">
                <label class="label">
                  <span class="label-text">Linkedin</span>
                </label>
                <input
                  type="text"
                  placeholder="linkedin"
                  class="input input-bordered"
                  name="linkedin"
                />
              </div>

              <div class="form-control mt-6">
                <button class="btn btn-primary bg-cyan-800 text-white">
                  Update Profile
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className="mt-14">
          <h1 className="text-xl ">
            <span className="text-cyan-800 font-semibold">Name</span>:
            {user?.displayName}
          </h1>
          <h1>
            <span className=" text-xl mr-4">
              <span className="text-cyan-800 font-semibold">Email</span>:
            </span>
            {user?.email}
          </h1>
          <h1>
            <span className=" text-xl mr-4">
              <span className="text-cyan-800 font-semibold">Education</span>:
            </span>
            {education || "Not found"}
          </h1>
          <h1>
            <span className=" text-xl mr-4">
              <span className="text-cyan-800 font-semibold">Address</span>:
            </span>
            {address || "Not found"}
          </h1>
          <h1>
            <span className=" text-xl mr-4">
              <span className="text-cyan-800 font-semibold">Linkedin</span>:
            </span>
            {linkedin || "Not found"}
          </h1>
          <h1>
            <span className=" text-xl mr-4">
              <span className="text-cyan-800 font-semibold">Number</span>:
            </span>
            {number || "Not found"}
          </h1>
        </div>
      </div>
    </div>
  );
};
export default MyProfile;
